import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated()) {
      if (this.ssoAlreadyChecked(state.url)) {
        return this.router.createUrlTree(
          ['/login'],
          { queryParams: { returnUrl: state.url, sso: 'checked' } }
        );
      }
      if (this.authService.beginSso(state.url)) {
        return false;
      }
      return this.router.createUrlTree(
        ['/login'],
        { queryParams: { returnUrl: state.url, sso: 'checked' } }
      );
    }

    const requiredRoles = route.data && route.data['roles'] as string[];
    if (requiredRoles && requiredRoles.length && !this.authService.hasAnyRole(requiredRoles)) {
      const deniedRedirect = (route.data && route.data['deniedRedirect']) || '/access-denied';
      return this.router.createUrlTree([deniedRedirect]);
    }

    return true;
  }

  private ssoAlreadyChecked(url: string): boolean {
    return !!url && url.indexOf('sso=checked') !== -1;
  }
}
